<template>
  <!--  <intersect @enter="animate = true" :threshold="[0, 0.15, 0.25,0.35,0.45, 0.5, 0.75,0.85,0.95, 1]">-->
  <section
    class="container widgets-container mt-55 fadeUp"
    v-if="_.size(slidesList) !== 0"
    :class="animate ? 'animate' : ''"
  >

    <h2 v-if="currentMenu.teaser2" class="other-title fadeUp animate">{{ currentMenu.teaser2 }}</h2>

    <swiper
      ref="mySwiper"
      :options="swiperOptions"
      class="widget-slider"
      :class="
        _.size(slidesList) == 3
          ? 'with-3-items'
          : '' || _.size(slidesList) == 2
          ? 'with-2-items'
          : '' || _.size(slidesList) == 1
          ? 'with-1-item'
          : '' || _.size(slidesList) > 3
          ? 'slider-component'
          : ''
      "
    >
      <swiper-slide
        v-for="slide in slidesList"
        :key="`${slide.id}-parent`"
        :class="_.size(slide.children) ? 'with-links' : 'with-button'"
        class="widget-slide"
      >
        <div class="img-box br-12 paralaxe" v-if="_.size(slidesList) == 1 || _.size(relatedMenu)">
          <picture>
            <source
              media="(max-width: 767px)"
              :srcset="_.get(slide, 'media.cover.devices.mobile')"
            />
            <source
              media="(max-width: 1023px)"
              :srcset="_.get(slide, 'media.cover.devices.tablet')"
            />
            <img
              :src="_.get(slide, 'media.cover.devices.desktop')"
              class="img-absolute"
              alt
              v-prlx="{ speed: 0.08 }"
            />
          </picture>

          <div class="gradient"></div>
          <div class="img-overlay"></div>
          <div class="widget-content">
            <h3 class="other-title white">{{ slide.title }}</h3>
            <p class="white">{{ slide.teaser }}</p>
          </div>
          <router-link :to="slide.full_url" class="bg-white btn">
            <span class="font-14 noto-semibold">{{ $fn.tr("discover") }}</span>
          </router-link>
        </div>
        <div class="img-box br-12" v-else>
          <picture>
            <source
              media="(max-width: 767px)"
              :srcset="_.get(slide, 'media.cover.devices.mobile')"
            />
            <source
              media="(max-width: 1023px)"
              :srcset="_.get(slide, 'media.cover.devices.tablet')"
            />
            <img
              :src="_.get(slide, 'media.cover.devices.desktop')"
              class="img-absolute"
              alt
            />
          </picture>
          <div class="gradient"></div>
          <div class="img-overlay"></div>
          <div class="widget-content">
            <h3 class="other-title white">{{ slide.title }}</h3>
            <p class="white">{{ slide.teaser }}</p>
          </div>
          <router-link :to="slide.full_url" class="bg-white btn">
            <span class="font-14 noto-semibold">{{ $fn.tr("discover") }}</span>
          </router-link>
        </div>

        <div class="widget-links flex-box al-center justify-center column" v-if="_.get(slide, 'children')">
          <div class="links-container">
            <h4 class="links-title white">
              <template v-if="slide.css.includes('has-link')">
                <router-link class="white" :to="slide.full_url">
                  {{ _.get(slide, "parent_title") }}
                </router-link>
              </template>
              <template v-else>
                {{ _.get(slide, "parent_title") }}
              </template>
            </h4>
            <ul>
              <li
                v-for="(link, linkIndex) in _.get(slide, 'children')"
                :key="`${linkIndex}-child`"
                :class="[
                  link.id == _.get($store.state.breadcrumbsLeveled, 'lvl4')
                    ? 'active'
                    : '',
                ]"
              >
                <router-link :to="link.full_url">{{ link.title }}</router-link>
              </li>
            </ul>
          </div>
        </div>

      </swiper-slide>

      <div
        class="widget-button-prev"
        slot="button-prev"
        tabindex="0"
        role="button"
        aria-label="Previous slide"
        aria-disabled="true"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="12.013"
          height="21.906"
          viewBox="0 0 12.013 21.906"
        >
          <g
            id="Group_70"
            data-name="Group 70"
            transform="translate(42.561 -19626.655) rotate(-90)"
          >
            <path
              id="Path_61"
              data-name="Path 61"
              d="M0,9.892,9.892,0"
              transform="translate(-19637.607 -41.5)"
              fill="none"
              stroke="#444958"
              stroke-linecap="round"
              stroke-width="1.5"
            />
            <path
              id="Path_60"
              data-name="Path 60"
              d="M9.892,9.892,0,0"
              transform="translate(-19647.5 -41.5)"
              fill="none"
              stroke="#444958"
              stroke-linecap="round"
              stroke-width="1.5"
            />
          </g>
        </svg>
      </div>
      <div
        class="widget-button-next"
        slot="button-next"
        tabindex="0"
        role="button"
        aria-label="Next slide"
        aria-disabled="false"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="12.013"
          height="21.906"
          viewBox="0 0 12.013 21.906"
        >
          <g
            id="Group_70"
            data-name="Group 70"
            transform="translate(42.561 -19626.655) rotate(-90)"
          >
            <path
              id="Path_61"
              data-name="Path 61"
              d="M0,9.892,9.892,0"
              transform="translate(-19637.607 -41.5)"
              fill="none"
              stroke="#444958"
              stroke-linecap="round"
              stroke-width="1.5"
            />
            <path
              id="Path_60"
              data-name="Path 60"
              d="M9.892,9.892,0,0"
              transform="translate(-19647.5 -41.5)"
              fill="none"
              stroke="#444958"
              stroke-linecap="round"
              stroke-width="1.5"
            />
          </g>
        </svg>
      </div>
    </swiper>
  </section>
  <!--  </intersect>-->
</template>

<script>
import Vue from "vue";
import mainMixin from "@/mixins/main";
import AliMixin from "@/mixins/ali";
const Intersect = () => import("vue-intersect");
// import Intersect from "vue-intersect";
import Paralax from "@/assets/js/paralax.js";
Vue.directive("prlx", Paralax);

export default {
  mixins: [mainMixin, AliMixin],
  components: { Intersect },
  data() {
    return {
      currentLength: null,
      currentSlides: {},
      swiperOptions: {},
      animate: false,
    };
  },
  props: ["itemData"],
  mounted() {
    if (_.size(this.relatedMenu)) {
      this.currentLength = _.size(this.relatedMenu);
      this.currentSlides = this.relatedMenu;
    } else {
      this.currentLength = _.size(this.secondLevelMenu);
      this.currentSlides = this.secondLevelMenu;
    }
    this.animate = true;
  },
  computed: {
    currentMenu() {
      return this.$store.state.selected_menu
    },
    secondLevelMenu(){
      if (!this.$store.getters.menuStatus("level2")) return {};
      return this.getMenuFlat( "main", this.$store.getters.menuStatus("level2") )
    },
    relatedMenu() {
      if (this.currentMenu.related_menus && this.currentMenu.related_menus.length) {
        const menus = this.getMultipleMenuByIds(this.currentMenu.related_menus);
        if (menus && menus.length) {
          return menus;
        }

        return []
      };

      return []
    },
    slidesList() {
      let mainList = this.secondLevelMenu;

      if (_.size(this.relatedMenu)) {
        return this.relatedMenu
      }

      // console.log(mainList)
      let ret = {};
      for (let i in mainList) {
        //hide-from-widgets
        if (
          _.get(mainList[i], "css") &&
          Array.isArray(mainList[i].css) &&
          mainList[i].css.indexOf("hide-from-widgets") >= 0 &&
          mainList[i].pid === this.$store.state.selected_menu.id &&
          mainList[i].css.indexOf("enable-sibling-headbanner") < 0
        )
          continue;

        mainList[i].parent_title = _.get(mainList[i], "title");
        mainList[i].parent_teaser = _.get(mainList[i], "teaser");
        // console.log(JSON.stringify(this.$store.state.breadcrumbsLeveled));
        // console.log(JSON.stringify(this.$store.state.breadcrumbsLeveled));

        //// if selected entry select only its parent and childs /// one banner style
        if (
          _.get(this.$store.state.breadcrumbsLeveled, "lvl4") &&
          _.get(this.$store.state.breadcrumbsLeveled, "lvl3") != mainList[i].id
        )
          continue;

        let subList = this.getMenuFlat("main", mainList[i].id);
        let tmp = {};
        for (let ii in subList) {
          //// if selected exact content use its title, teaser and image for banner content
          if (
            _.get(this.$store.state.breadcrumbsLeveled, "lvl4") ==
            subList[ii].id
          ) {
            if (_.get(subList[ii], "media.cover"))
              _.set(
                mainList[i],
                "media.cover",
                _.get(subList[ii], "media.cover")
              );
            _.set(mainList[i], "title", _.get(subList[ii], "title"));
            _.set(mainList[i], "teaser", _.get(subList[ii], "teaser"));
          }
          /// if link has 'single-card', set as card and continue
          if (
            _.get(subList[ii], "css") &&
            Array.isArray(subList[ii].css) &&
            subList[ii].css.indexOf("single-card") >= 0
          ) {
            ret[subList[ii].id] = subList[ii];
            // console.log(subList[ii]);
            continue;
          }

          /// set childs to parent
          if (!ret[mainList[i].id]) ret[mainList[i].id] = mainList[i];
          if (!ret[mainList[i].id].children) ret[mainList[i].id].children = [];
          // console.log(subList[ii]);
          ret[mainList[i].id].children.push(subList[ii]);
        }

        /// if parent has only one child set child as card
        if (
          _.get(ret, [[mainList[i].id], "children"]) &&
          _.size(ret[mainList[i].id].children) == 1
        ) {
          ret[mainList[i].id] = _.get(ret[mainList[i].id].children, 0);
        }
      }
      ret = _.orderBy(ret, ["sort"], ["asc"]);

      return ret;
    },

    swiper() {
      return this.$refs.mySwiper.$swiper;
    }
  },

  methods: {
    widgetF: function() {
      if (_.size(this.relatedMenu)) {
        this.currentLength = _.size(this.relatedMenu);
        this.currentSlides = this.relatedMenu;        
      } else {
        this.currentLength = _.size(this.secondLevelMenu);
        this.currentSlides = this.secondLevelMenu;
      }
      if (_.size(this.slidesList) > 3) {
        this.swiperOptions = {
          spaceBetween: 20,
          speed: 700,
          slidesPerView: 3,
          updateOnWindowResize: true,
          resizeReInit: true,

          navigation: {
            nextEl: ".widget-button-next",
            prevEl: ".widget-button-prev"
          },
          breakpoints: {
            300: {
              slidesPerView: 1.05
            },
            768: {
              slidesPerView: 1.5
            },
            1024: {
              slidesPerView: 2.5
            },
            1366: {
              slidesPerView: 3
            }
          }
        };
      } else {
        this.swiperOptions = {
          init: false
        };
      }
    }
  },

  beforeMount() {
    this.widgetF();
    // window.addEventListener("resize", this.widgetF);
  },
  created() {
    window.addEventListener("resize", this.widgetF);
  }
};
</script>


<style >
.widget-slide.with-button .widget-links {
  display: none;
}
.widget-slide.with-links .btn {
  display: none;
}
.widget-slide.with-links .img-overlay {
  display: none;
}
.img-box.paralaxe {
  overflow: hidden;
}
.widget-content p {
  display: -webkit-box;
  overflow: hidden;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
}
@media (max-width: 767px) {
  .widget-slide .img-box .gradient {
    display: none;
  }
  .links-container {
    max-height: unset;
  }
  .links-container ul {
    max-height: 150px;
  }
}
@media (max-width: 499px) {
  .links-container ul {
    max-height: 127px;
  }
}
@media (max-width: 450px) {
  .widget-content p {
    display: none;
  }
  .widget-content .other-title {
    margin-bottom: 10%;
  }
}

.main-page-router-view[path2="loans"] .widgets-container::after,
.main-page-router-view[path1="business"] .widgets-container::after,
.main-page-router-view[path1="unique-banking"] .widgets-container::after {
  display: none;
}
</style>

